import {
    formatAsMonthDayYearUTC,
    transformEnumToDisplay,
} from '@fruitful/fruitils';
import { type ImInvestorDocument } from '@fruitful/types';
import * as Linking from 'expo-linking';
import { Platform } from 'react-native';
import {
    BodyMediumRegular,
    FileTextIcon,
    NavigationRow,
    RowList,
} from 'smoothie';

import { useTrackViewOnFocus } from '../../../events/hooks/useTrackViewOnFocus';

// transformEnumToDisplay lowercases all words after the first, but alphabetic
// suffixes on tax form names (e.g. "R" in 1099-R, "ESA" in 5498-ESA) must
// stay fully uppercase since they are acronyms/letter-codes, not prose words.
const formatDocumentType = (documentType: string): string =>
    transformEnumToDisplay(documentType)
        .split(' ')
        .map((word) => (/^[a-z]{1,3}$/.test(word) ? word.toUpperCase() : word))
        .join(' ');

export const DocumentLinkList = ({
    getDocumentDownloadUrl,
    accountDocuments,
    documentTypeName,
}: {
    getDocumentDownloadUrl: (document: ImInvestorDocument) => Promise<string>;
    accountDocuments: ImInvestorDocument[];
    documentTypeName: string;
}) => {
    useTrackViewOnFocus('Investment/Documents/List');
    return accountDocuments.length === 0 ? (
        <BodyMediumRegular marginTop={100} textAlign="center" width="100%">
            This account has no {documentTypeName} currently available.
        </BodyMediumRegular>
    ) : (
        <RowList width="100%">
            {accountDocuments.map((accountDocument) => (
                <NavigationRow
                    key={accountDocument.name}
                    title={formatDocumentType(
                        accountDocument.investorDocument.documentType,
                    )}
                    subtitle={formatAsMonthDayYearUTC(
                        new Date(
                            accountDocument.investorDocument.processDate.year,
                            accountDocument.investorDocument.processDate.month -
                                1,
                            accountDocument.investorDocument.processDate.day,
                        ),
                    )}
                    leftIcon={FileTextIcon}
                    onPress={async () => {
                        /* TODO: Add loading visual indicator */
                        const url =
                            await getDocumentDownloadUrl(accountDocument);
                        if (Platform.OS === 'web') {
                            window.open(url, '_blank');
                        } else {
                            void Linking.openURL(url);
                        }
                    }}
                />
            ))}
        </RowList>
    );
};
